import { DocumentacionBaremoPexENTITY,  DocumentacionPEXENTITY,  ManoObraGlobalENTITY, PrecioEspecialidadENTITY } from 'sigo-entities'
import { DtoDocumentacionPEX } from '../../../../../app/Domain/DtoDocumentacionPEX'
import { DtoItems } from '../../../../../app/Domain/DtoItems'
import { DtoPrecioMaterial } from '../../../../../app/Domain/DtoPrecioMaterial'
import { DtoResponseEstadoInterno } from '../../../../../app/Domain/DtoResponseEstadoInterno'
import { DtoConsumoMaterial } from '../../../../Master/Home/Domain/DtoConsumoMaterial'
import { DtoResponseSelectStockPersonal } from '../../../../Master/Home/Domain/DtoResponseSelectStockPersonal'
import { DtoStockAlmacen } from '../../../../Master/Home/Domain/DtoStockAlmacen'
import { EntityDataUsuario } from '../../../../shared/Domain/EntityDataUsuario'
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate'
import { DtoTrabajosDE } from '../../Lista/Domain/DtoTrabajosDE'
import { EntityLoadData } from '../Domain/EntityLoadData'
import { RepositoryMain } from '../Domain/RepositoryMain'

export class UseCaseLoadData {
  private repository: RepositoryMain
  private languageTranslate = LanguageTranslate()

  constructor(_repository: RepositoryMain) {
    this.repository = _repository
  }

  async exec(user: EntityDataUsuario, trabajo: DtoTrabajosDE): Promise<EntityLoadData> {
    const [
      DocumentacionPEX,
      DocumentacionBaremoPEX,
      ManoObraGlobal,
      dataItems,
      dataStockPersonal,
      EstadosInternos,
      PrecioEspecialidad,
      dataPrecioMaterial,
      dataStockAlmacen,
      dataConsumoMaterial,
    ] = await Promise.all([
      this.getDocumentacionPEX(user),
      this.getDocumentacionBaremoPEX(user, trabajo),
      this.getManoObraGlobal(user),
      this.getItems(user),
      this.getStockPersonal(user, trabajo),
      this.getEstadoInterno(user),
      this.getPrecioEspecialidad(user),
      this.getPrecioMaterial(user),
      this.getStockAlmacen(user),
      this.getConsumoMaterial(user),
    ])
    return {
      DocumentacionPEX,
      DocumentacionBaremoPEX,
      dataItems,
      dataStockPersonal,
      ManoObraGlobal,
      EstadosInternos,
      PrecioEspecialidad,
      dataPrecioMaterial,
      dataStockAlmacen,
      dataConsumoMaterial
    }
  }

  private async getEstadoInterno(user: EntityDataUsuario): Promise<DtoResponseEstadoInterno[]> {
    const data = await this.repository.selectEstadoInterno();
    return data.filter(e => e.Tipo === 'Amap' && e.Pais.Codigo === user.Pais.Codigo);
  }

  private async getDocumentacionPEX(user: EntityDataUsuario): Promise<DocumentacionPEXENTITY[]> {
    const items = await this.repository.selectDocumentacionPEX()
    const itemsAux = items.filter(e =>
      e.Pais.Codigo === user.Pais.Codigo &&
      e.Delegacion.Codigo === user.Delegacion.Codigo &&
      e.Codigo === 'docDP'
    )
    if (itemsAux.length !== 1) throw Error(this.languageTranslate.general.No_se_pudo_encontrar_documentación_para_Calidad_Refresque_DocumentaciónPEX)
    return itemsAux
  }

  private async getStockAlmacen(user: EntityDataUsuario): Promise<DtoStockAlmacen[]> {
    const stock = await this.repository.selectStockAlmacen(user)
    return stock
  }

  private async getDocumentacionBaremoPEX(user: EntityDataUsuario, trabajo: DtoTrabajosDE): Promise<DocumentacionBaremoPexENTITY[]> {
    if (trabajo.ColeccionObras.length !== 1) throw new Error(this.languageTranslate.general.Error_al_obtener_Obra_Comunícate_con_Soporte)
    const items = await this.repository.selectDocumentacionBaremoPEX()
    return items.filter(e => e.Pais.Codigo === user.Pais.Codigo && e.Delegacion.Codigo === user.Delegacion.Codigo && e.ContratoCod === trabajo.ColeccionObras[0].ContratoOT.Codigo)
  }

  private async getStockPersonal(user: EntityDataUsuario, trabajo: DtoTrabajosDE): Promise<DtoResponseSelectStockPersonal[]> {
    const stockPersonal = await this.repository.selectStockPersonal(user);
    return stockPersonal.filter(e => e.ID_Trabajo === trabajo.ID_Trabajo);
  }

  private async getConsumoMaterial(user: EntityDataUsuario,): Promise<DtoConsumoMaterial[]> {
    const data = await this.repository.selectConsumoMaterial(user)
    return data
  }

  private async getItems(user: EntityDataUsuario): Promise<DtoItems[]> {
    const items = await this.repository.selectItems();   
    return items.filter(e => e.Pais.Codigo === user.Pais.Codigo && e.Delegacion.Codigo === user.Delegacion.Codigo);
  }

  private async getManoObraGlobal(user: EntityDataUsuario): Promise<ManoObraGlobalENTITY[]> {
    const data = await this.repository.selectManoObraGlobal()
    return data.filter(e => e.Pais.Codigo === user.Pais.Codigo && e.Delegacion.Codigo === user.Delegacion.Codigo)
  }

  private async getPrecioEspecialidad(user: EntityDataUsuario): Promise<PrecioEspecialidadENTITY[]> {
    const data = await this.repository.selectPrecioEspecialidad()
    return data.filter(e => e.Pais.Codigo === user.Pais.Codigo && e.Delegacion.Codigo === user.Delegacion.Codigo)
  }

  private async getPrecioMaterial(user: EntityDataUsuario): Promise<DtoPrecioMaterial[]> {
    const items = await this.repository.selectPrecioMaterial()
    return items.filter(e => e.Pais.Codigo === user.Pais.Codigo && e.Delegacion.Codigo === user.Delegacion.Codigo)
  }

}